/* eslint-env browser */

    var current = 0
    var timer
    var slider
    var nav
    var width
    var parentWidth;
    var transformProp = 'transform';
    var children


    function set () {
      current += 1
      if (current === slider.children.length) current = 0;
      var position = '-' + parentWidth * current + 'px'
      slider.style[transformProp] = 'translate('+position+', 0)'
    }

    function play () {
      timer = setInterval(set, 3500)
    }

    function stop () {
      clearInterval(timer)
    }

    function init (node) {
        timer && (clearInterval(timer), timer = 0);
        slider = node;
            if (slider) {
                parentWidth = slider.parentNode.clientWidth;
                children = slider.children.length
                width = slider.clientWidth * children;
                slider.style.width = width+'px';
                for (var i = 0; i < children; i++) {
                    slider.children[i].style.width = parentWidth+'px';
                    slider.children[i].style.height = slider.children[0].children[0].clientHeight+'px';
                }
                slider.style.height = slider.children[0].children[0].clientHeight+'px';

                if (children > 1) {
                    play()
                }
            } else {
                slider = nav = null
            }
    }

    window.addEventListener('resize', function () {
      if (slider) {
        requestAnimationFrame(function () {
          current -= 1
            parentWidth = slider.parentNode.clientWidth;
            width = slider.clientWidth * children;
            slider.style.width = width+'px';
            set()
            for (var i = 0; i < children; i++) {
                slider.children[i].style.width = parentWidth+'px';
                slider.children[i].style.height = slider.children[0].children[0].clientHeight+'px';
            }
            slider.style.height = slider.children[0].children[0].clientHeight+'px';
        })
      }
    })

module.exports = {
  sliderSetup: init
};
